import { render, staticRenderFns } from "./ConfigCategoryMap.vue?vue&type=template&id=dba76620&"
import script from "./ConfigCategoryMap.vue?vue&type=script&lang=js&"
export * from "./ConfigCategoryMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports